import "./core/compatibility.js";
import "./core/errorLogger.js";
import "./core/iframeBuster.js";
import "./core/widgets/widgetExtensions.js";
import { runHooks } from "./core/ConfigurationManager.js";
import app from "./external/app.js";
import InternationalizationService from "./core/services/InternationalizationService.js";
import loadApplication from "./core/loadApplication.js";
import NullCompany from "./models/NullCompany.js";
import session from "./core/session.js";
import userFactory from "./models/userFactory.js";

const options = window.appConfig;
if (!options) {
	throw new Error("Configuration (appConfig) options are required. ");
}

session.setAntiForgeryToken(options.antiForgeryToken);
session.setInternationalizationService(InternationalizationService.instance());
session.setCurrentUser(userFactory.materialize(options.currentUser));
session.setCompany(NullCompany.instance());
session.setAgency(options.agency);
session.setCountry(options.country);
session.notifications = options.notifications || {};
session.wkIdEnabled = options.wkIdEnabled;

runHooks(window.finsitHooks, options);

const instance = app();

window.app = instance;

loadApplication({ instance, options });
